import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ModalWrapper } from '../ModalWrapper';
import { CloseIconWrapper, Wrapper } from '../SaveModal/SaveModal.style';
import { ReactComponent as CloseIcon } from 'assets/icons/closeIcon.svg';
import { clearErrors } from 'store/features/context/actions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DisplayErrors from './DisplayErrors';
import { selectUploadErrorsModal } from 'store/features/context/selectors';
import { useCallback } from 'react';

const UploadModal = () => {
    const dispatch = useAppDispatch();
    const errors = useAppSelector(selectUploadErrorsModal);
    const onClose = useCallback(() => dispatch(clearErrors()), [dispatch]);
    return (
        <ModalWrapper open={Boolean(errors?.length)}>
            <Wrapper>
                <Typography variant='h1' mb='16px'>
                    {errors.length === 1 ? 'Nie można dodać pliku' : 'Nie można dodać plików'}
                </Typography>
                <Box mb='16px' maxHeight='132px' sx={{ overflowY: 'auto' }}>
                    <Typography paragraph m='0'>
                        {errors.length === 1 ? errors[0].error : null}
                    </Typography>
                    {errors.length > 1 ? <DisplayErrors errors={errors} /> : null}
                </Box>
                <Box display='flex' justifyContent='flex-end'>
                    <Button variant='text' onClick={onClose} sx={{ textTransform: 'none' }}>
                        Zamknij
                    </Button>
                </Box>
                <CloseIconWrapper>
                    <CloseIcon onClick={onClose} />
                </CloseIconWrapper>
            </Wrapper>
        </ModalWrapper>
    );
};

export default UploadModal;
